import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Redirect, Switch, useLocation, Route } from 'react-router-dom';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getMenuItens } from '../../services/utils';
import { sendEmailPwd } from '../../services/usuario';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  //AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';

import { Page404 } from '../../views/Pages';

// routes config
import routes from '../../routes';
import ProtectedRoute from '../../components/ProtectedRoute';
import * as notificacoesService from '../../services/notificacoes';

import BackButton from '../../components/BackButton';

import { checkVisibileInViewport, getConfigAll } from '../../util/helper';

const DefaultAside = React.lazy(() => import('./DefaultAside'));
const DefaultFooter = React.lazy(() => import('./DefaultFooter'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));

const menuHoverEventBind = () => {
  const elements = document.querySelectorAll('.nav-item.nav-dropdown');

  if (elements) {
    Array.from(elements).forEach((item) => {
      item.addEventListener(
        'mouseenter',
        function (event) {
          const child = item.querySelector('.nav-dropdown-items');
          if (!checkVisibileInViewport(child))
            child.classList.add('menu-position-up');
        },
        false
      );
    });
  }
};

const DefaultLayout = (props) => {
  const {
    auth: { user },
  } = props;
  const location = useLocation();
  const [notificacoes, setNotificacoes] = useState([]);
  const [menu, setMenu] = useState([]);
  const [isInactive, setIsInactive] = useState(false);
  const inactivityTimer = useRef(null);
  const [inactivityTimeout, setInactivityTimeout] = useState(15);

  const inactivityTimeoutRef = useRef(inactivityTimeout);

  useEffect(() => {
    inactivityTimeoutRef.current = inactivityTimeout;
  }, [inactivityTimeout]);

  const handleInactivity = () => {
    localStorage.clear();
    sessionStorage.clear();
    setIsInactive(true); 
    toast.error(`Logoff devido inatividade após ${inactivityTimeoutRef.current } minutos`, 5000);
    
  };


   const resetTimer = async () => {
    clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(handleInactivity, inactivityTimeoutRef.current * 60 * 1000);
  };

  useLayoutEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'keypress', 'scroll'];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer, true);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer, true);
      });
    };
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      const config = await getConfigAll(); 
      if (config && config.logoffInatividadeMinutos) {
        setInactivityTimeout(config.logoffInatividadeMinutos); 
      }
    };

    fetchConfig();

    return () => {
      clearTimeout(inactivityTimer.current);
    };
  }, []); 

  useEffect(() => {
    resetTimer();
  }, [inactivityTimeout]); 


  const inDashboard =
    window.location.hash === '#/' || window.location.hash === '#/dashboard'
      ? true
      : window.location.hash === '#/pagina-inicial'
        ? true
        : false;


  const getMenuItems = async () => {
    let menuItems = await getMenuItens();

    setTimeout(() => {
      menuHoverEventBind();
    }, 0);

    setMenu(menuItems);
  };

  const fetchNotifications = async () => {
    const notificacoes = await notificacoesService.getAll();
    const notificacoesFilter = notificacoes.map(item => ({
      IdNotificacao: item._id,
      IdUsuario: item._idUsuario,
      Titulo: item.produto.nome,
      Texto: item.mensagem.titulo,
      Url: item.mensagem.file,
      DataInclusao: item.createAt,
      Tipo: item.mensagem.template,
      Exibir: true,
    }))

    setNotificacoes(notificacoesFilter);
  };

  const onClickEnviarEmailPwd = async () => {
    try {
      const result = await sendEmailPwd(user);

      if (result.success) {
        toast.success(result.msg);
      } else {
        toast.error(result.msg);
      }
    } catch (error) {
      toast.error('Não foi possível o e-mail para troca de senha');
    }
  }

  const renderToastPwd = (text) => {
    return (
      <div>
        <p>{text}</p>

        <button onClick={onClickEnviarEmailPwd} className='btn btn-warning btn-sm' >Enviar e-mail</button>
      </div>
    )
  }

  useEffect(() => {
    getMenuItems();

    if (user?.daysLastChangePwd >= 28) {
      let msg = ''
      switch (user?.daysLastChangePwd) {
        case 28:
          msg = 'Sua senha irá expirar em 02 dias. Clique abaixo e cadastre uma nova senha.';
          break;
        case 29:
          msg = 'Sua senha irá expirar em 01 dias. Clique abaixo e cadastre uma nova senha.';
          break;
        case 30:
          msg = 'Sua senha expira hoje. Clique abaixo e cadastre uma nova senha.';
          break;
        default:
          msg = 'Sua senha expirou! Para sua segurança acesse seu e-mail e siga as orientações para novo cadastro';
          onClickEnviarEmailPwd();
      }

      toast.warn(renderToastPwd(msg));
    }

    if (!!user) {
      fetchNotifications();
      setInterval(fetchNotifications, 30000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      window.location.hash === '#/dashboard' ||
      window.location.hash === '#/pagina-inicial'
    ) {
      menu.map((item) => {
        if (item.chave === 'Dashboard' || item.chave === 'PaginaInicial')
          props.history.push(item.url);
      });
    }
  }, [menu]);

  useEffect(() => {
    let currentRoute = routes[routes.findIndex((item) => item.path === location.pathname)];
    const userKey = '_nscorporate_user';
    let usernew = JSON.parse(sessionStorage.getItem(userKey));
    if (!usernew || !currentRoute?.IdAplicacao || !currentRoute?.IdAplicacaoCliente) return;
    usernew.current_idaplicacao = currentRoute.IdAplicacao;
    usernew.current_idaplicacaocliente = currentRoute.IdAplicacaoCliente;
    sessionStorage.setItem(userKey, JSON.stringify(usernew));
  }, [location]);

  if (isInactive || !user) return <Redirect from="/" to="/login" />;

  return (
    <React.Fragment>
      <div className="app">
        <ToastContainer
          position="top-right"
          autoClose={7000}
          style={{ zIndex: 1999 }}
        />
        <AppHeader fixed>
          <DefaultHeader
            user={user}
            notificacoesNaoLidas={!!notificacoes ? notificacoes.length : 0}
          />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="md" style={{ fontSize: '12px', maxWidth: '200px' }}>
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav
              style={{ paddingBottom: '30px' }}
              history={props.history}
              location={props.location}
              match={props.match}
              navConfig={{ items: menu }}
              router={routes}
              {...props}
            />
            <AppSidebarFooter />
            {/* <AppSidebarMinimizer /> */}
          </AppSidebar>
          <main className="main"
            style={{ padding: '0' }}
          >
            {!inDashboard && (
              <AppBreadcrumb
                appRoutes={routes}
              />
            )}
            <Container
              fluid
              className={
                'position-relative ' + (inDashboard ? 'in-dashboard' : '')
              }
            >
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <ProtectedRoute
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      permissionKey={route.permissionKey}
                      isProtected={route.protected}
                      render={({ IdAplicacao, IdAplicacaoCliente, ...routeProps }) => (
                        <route.component {...routeProps} user={user} />
                      )}
                    />
                  ) : null;
                })}

                {/* <Route path="/" component={Dashboard} /> */}

                {location.pathname === "/" && <Redirect from="/" to="/pagina-inicial" />}

                <Route path="*" component={Page404} />

              </Switch>
            </Container>
            <BackButton />
          </main>
          <AppAside fixed>
            <DefaultAside notificacoes={notificacoes} />
          </AppAside>
        </div>
        <AppFooter className={inDashboard ? 'in-dashboard-footer' : ''}>
          <DefaultFooter />
        </AppFooter>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(DefaultLayout);
